<template>
  <div>
    <div class="loggingstored-title">
      <div>{{ $t("RAM.GCP.loggingstored.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:gcp:log:loggingstored:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:gcp:log:loggingstored:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="loggingstored-top">
      <loggingstored-search ref="child"></loggingstored-search>
    </div>
    <table-loggingstored></table-loggingstored>
    <export ref="exportChild"></export>
  </div>
</template>

<script>
import LoggingstoredSearch from "./LoggingstoredSearch";
import TableLoggingstored from "./TableLoggingstored";
import Export from "../../Export";

export default {
  name: "Loggingstored",
  components: {
    LoggingstoredSearch,
    TableLoggingstored,
    Export
  },
  data() {
    return {
      loading: false,
      modal_loading: false,
      companyId: "",
      pageNum: "",
      pageSize: ""
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.companyId = this.$refs.child.companyId;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 405,
          accountType: 1
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success("更新成功");
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      var exportDTO = {
        accountName: this.$refs.child.accountName,
        companyId: this.$refs.child.companyId,
        resourceName: this.$refs.child.loggingstoredName,
        pageNum: this.$refs.child.pageNum,
        pageSize: this.$refs.child.pageSize
      };
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportGcpLoggingStoredGroup(exportDTO)
        .then(res => {
          let fileName = "日志存储.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success("导出成功");
        });
    }
  }
};
</script>

<style scoped>
.loggingstored-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.loggingstored-title > div:nth-child(1) {
  float: left;
}
.loggingstored-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.loggingstored-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/gcp/cloudLogging/log/Loggingstored.vue